module.exports = __webpack_public_path__ + "static/media/partitionDividing.2472a259.png";